import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs, doc, getDoc, setDoc, updateDoc, addDoc } from 'firebase/firestore';
import { db, auth } from '../Firebase/Firebase';
import Navbar from '../Components/NavBarAirbnbStyle';
import Modal from 'react-modal';
import './reservasAdmin.css';
import Rating from 'react-rating-stars-component'; // Componente para las estrellas
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

Modal.setAppElement('#root');
const ReservasFiltradas = () => {
    const [reservations, setReservations] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [noSpaces, setNoSpaces] = useState(false);
    const [noReservations, setNoReservations] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedReserva, setSelectedReserva] = useState(null);
    const [calificacion, setCalificacion] = useState(0);
    const [comentario, setComentario] = useState('');
    const [showWarningModal, setShowWarningModal] = useState(false); // Modal de advertencia
    const [showAlertModal, setShowAlertModal] = useState(false); 

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                setIsLoading(true); // Iniciar estado de carga
                onAuthStateChanged(auth, async (user) => {
                    if (!user) {
                        setIsAdmin(false); // Usuario no autenticado
                        setReservations([]); // Limpiar reservas
                        setIsLoading(false); // Finalizar carga
                        return;
                    }
                    const userDocRef = doc(db, 'usuarios', user.uid);
                    const userDoc = await getDoc(userDocRef);

                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        const isAdminUser = userData.role === 'admin';
                        setIsAdmin(isAdminUser); // Actualizar estado local
                        await fetchFilteredReservations(user.uid, isAdminUser); // Pasar el rol calculado directamente
                    } else {
                        console.warn('El documento del usuario no existe.');
                        setIsAdmin(false);
                    }
                });
            } catch (error) {
                console.error('Error al obtener el estado del usuario:', error);
            } finally {
                setIsLoading(false); // Finalizar carga
            }
        };

        fetchUserData();
    }, []);

    const fetchFilteredReservations = async (uid, isAdminUser) => {
        try {
            let fetchedReservations = [];
            setNoSpaces(false);
            setNoReservations(false);

            if (isAdminUser) {
                const allReservationsQuery = query(collection(db, "reservas"));
                const querySnapshot = await getDocs(allReservationsQuery);
                fetchedReservations = await Promise.all(
                    querySnapshot.docs.map(async (reservationDoc) => {
                        const data = reservationDoc.data();
                        let nombreEspacio = "Espacio Desconocido";
                        let proveedor = "Desconocido";
                        let cliente = "Cliente Desconocido";
                        let clienteInfo = {};

                        if (data.idUser) {
                            const userDocRef = doc(db, "usuarios", data.idUser);
                            const userDoc = await getDoc(userDocRef);
                            if (userDoc.exists()) {
                                clienteInfo = userDoc.data();
                                cliente = `${clienteInfo.name || ""} ${clienteInfo.lastName || ""}`.trim() || "Cliente Sin Nombre";
                            }
                        }

                        if (data.IdEspacio) {
                            const espacioDocRef = doc(db, "espacios", data.IdEspacio);
                            const espacioDoc = await getDoc(espacioDocRef);

                            if (espacioDoc.exists()) {
                                const espacioData = espacioDoc.data();
                                nombreEspacio = espacioData.NombreEspacio || "Sin Nombre";
                                if (espacioData.IdLugar) {
                                    const lugarDocRef = doc(db, "lugar", espacioData.IdLugar);
                                    const lugarDoc = await getDoc(lugarDocRef);
                                    if (lugarDoc.exists()) {
                                        const lugarData = lugarDoc.data();
                                        if (lugarData.idUser) {
                                            const proveedorDocRef = doc(db, "usuarios", lugarData.idUser);
                                            const proveedorDoc = await getDoc(proveedorDocRef);
                                            if (proveedorDoc.exists()) {
                                                const proveedorData = proveedorDoc.data();
                                                proveedor = `${proveedorData.name || ""} ${proveedorData.lastName || ""}`.trim() || "Proveedor Sin Nombre";
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        return {
                            ...data,
                            id: reservationDoc.id, // Incluye el ID del documento
                            idEspacio: data.idEspacio || "Desconocido",
                            idUser: data.idUser || "Desconocido",
                            nombreEspacio,
                            proveedor,
                            cliente,
                            clienteInfo, // Incluye toda la información del usuario
                            calUsers: data.calUsers || false,
                        };
                    })
                );
            }

            setReservations(fetchedReservations);
        } catch (error) {
            console.error("Error al obtener las reservas filtradas:", error);
        }
    };

    const handlePuntuar = (reservation) => {
        // Verificamos si la reserva ya tiene calificación
        if (reservation.calUsers) {
            // Si ya calificó, mostrar el modal de advertencia
            setShowWarningModal(true);
        } else {
            // Si no calificó, asignamos la reserva seleccionada y mostramos el modal de calificación
            setSelectedReserva(reservation);
            setShowModal(true);
        }
    };
    const handleSaveCalificacion = async () => {
        try {
            if (!selectedReserva || !calificacion) {
                toast.error("Por favor, complete todos los campos para guardar la calificación.");
                return;
            }
            const reservation = selectedReserva;

            // Validar que los datos necesarios están presentes
            if (!reservation.idEspacio || !reservation.idUser || !reservation.proveedor) {
                console.error("Error: Datos incompletos en la reserva.");
                return;
            }

            // Construcción de los datos de calificación
            const calificacionData = {
                calificacion: calificacion,
                id_prov: reservation.proveedor, // Usa el proveedor de la reserva
                id_user: reservation.idUser,
                comentario: comentario,
            };

            // Guardar la calificación en la colección 'CalificacionUsers'
            const calificacionRef = collection(db, 'CalificacionUsers');
            const docRef = await addDoc(calificacionRef, calificacionData); // Agregar el documento y obtener el docRef

            // Obtener el ID del documento creado por Firestore
            const id_calificacion = docRef.id;

            // Ahora asignamos el ID de calificación generado por Firestore
            await updateDoc(docRef, {
                id_calificacion: id_calificacion, // Asignar el ID de Firestore al campo id_calificacion
            });

            // Actualizar solo el campo 'calUsers' en la reserva
            const reservaRef = doc(db, 'reservas', reservation.id); // Usamos la ID de la reserva seleccionada
            await updateDoc(reservaRef, {
                calUsers: true, // Indicamos que el usuario ha calificado
            });

            setShowAlertModal(true);
        } catch (error) {
            console.error("Error al guardar la calificación:", error);
        }
    };



    const closeModal = () => {
        setShowModal(false);
        setSelectedReserva(null);
        setCalificacion(0);
        setComentario('');
    };

    const closeAlertModal = () => {
        setShowAlertModal(false);
        window.location.reload(); // Recarga la página cuando se cierra el modal de calificación finalizada
    };

    const closeWarningModal = () => {
        setShowWarningModal(false);
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedReservation, setSelectedReservation] = useState(null);

    const openModal = (reservation) => {
        setSelectedReservation(reservation);
        setIsModalOpen(true);
    };

    const closeModal2 = () => {
        setSelectedReservation(null);
        setIsModalOpen(false);
      };
    return (
        <div>
            <Navbar />
            <ToastContainer />

            <div style={{ marginTop: '5em' }}>
                {isLoading ? (
                    <div>Cargando...</div>
                ) : (
                    <>
                    <br/><br/>
                        <h1>Reservaciones de mis Espacios</h1>
                        {noSpaces ? (
                            <p>No se encontraron espacios asociados a este anfitrión.</p>
                        ) : noReservations ? (
                            <p>No hay reservas disponibles para los espacios asociados.</p>
                        ) : reservations.length > 0 ? (
                            <table className='tabla_reservaciones'
                                border="1"

                            >
                                <thead style={{ backgroundColor: 'blanchedalmond' }}>
                                    <tr>
                                        <th>Espacio</th>
                                        <th>Cliente</th>
                                        {isAdmin && <th>Anfitrión</th>}
                                        <th>Costo</th>
                                        <th>Fecha Inicio</th>
                                        <th>Hora Inicio</th>
                                        <th>Fecha Final</th>
                                        <th>Hora Final</th>
                                        <th>Reseña Realizada</th>
                                        <th>Puntuar Cliente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reservations.map((reserva, index) => (
                                        <tr key={index}>
                                            <td>{reserva.nombreEspacio}</td>
                                            <td>{reserva.cliente}</td>
                                            {isAdmin && <td>{reserva.proveedor}</td>}
                                            <td>{reserva.costoReserva}</td>
                                            <td>{reserva.fechaInicio}</td>
                                            <td>{reserva.horaInicio}</td>
                                            <td>{reserva.fechaFinal}</td>
                                            <td>{reserva.horaFinal}</td>
                                            <td>{reserva.reseñaRealizada ? 'Sí' : 'No'}</td>
                                            <td>
                                                <button className='button_puntuar' onClick={() => handlePuntuar(reserva)}>Puntuar</button>
                                                <button className='button_ver_reserva' onClick={() => {
                                                    setSelectedReservation(reserva); // 'reservation' es el objeto de reserva seleccionado.
                                                    setIsModalOpen(true);
                                                }}>Datos usuario</button>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>Cargando...</p>
                        )}
                    </>
                )}
            </div>

            {/* Modal de calificación */}
            {showModal && (
                <div className="modal_res_prov">
                    <h2 style={{ marginBlockStart: '-0.17em' }}>Calificar Cliente</h2>

                    <div className='comentario_prov'>
                        <p>Calificación:</p>
                        <Rating
                            count={5}
                            value={calificacion}
                            onChange={setCalificacion}
                            size={30}
                            activeColor="#ffd700"
                        />
                        <p>Comentario:</p>
                        <textarea
                            style={{ width: '90%' }}
                            rows="4"
                            value={comentario}
                            onChange={(e) => setComentario(e.target.value)}
                        />
                    </div>

                    <div className='btnModal'>
                        <button className='cancelar_reseña' onClick={closeModal}>Cancelar</button>
                        <button className='guardar_reseña' onClick={handleSaveCalificacion}>Guardar</button>
                    </div>
                </div>
            )}

            {/* Modal de advertencia */}
            {showWarningModal && (
                <div className='advertencias_modal_reservas'>
                    <Modal style={{ inset: '0px' }} isOpen={showWarningModal} onRequestClose={closeWarningModal}>
                        <h2 style={{ color: 'red' }}>Advertencia</h2>
                        <p>Ya has calificado esta reserva.</p>
                        <button className='cerrar_modal_reservaciones' onClick={closeWarningModal}>Cerrar</button>
                    </Modal>
                </div>
            )}

            {/* Modal de alerta */}
            {showAlertModal && (
                <div>
                    <Modal isOpen={showAlertModal} onRequestClose={closeAlertModal}>
                        <h2 style={{ color: 'green' }}>¡Calificación guardada!</h2>
                        <p>La calificación ha sido registrada exitosamente.</p>
                        <button className='cerrar_modal_reservaciones' onClick={closeAlertModal}>Aceptar</button>
                    </Modal>
                </div>
            )}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal2}
                contentLabel="Detalles del Usuario"
                style={{
                    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
                    content: { maxWidth: "500px", margin: "auto" },
                }}
            >
                {selectedReservation && selectedReservation.clienteInfo && (
                    <div>
                        <h2>Detalles del Usuario</h2>
                        <p><strong>Cédula:</strong> {selectedReservation.clienteInfo.cedula || "No disponible"}</p>
                        <p><strong>Nombre:</strong> {selectedReservation.clienteInfo.name || "No disponible"}</p>
                        <p><strong>Apellido:</strong> {selectedReservation.clienteInfo.lastName || "No disponible"}</p>
                        <p><strong>Email:</strong> {selectedReservation.clienteInfo.email || "No disponible"}</p>
                        <p><strong>Teléfono:</strong> {selectedReservation.clienteInfo.phone || "No disponible"}</p>
                        <p><strong>RUC:</strong> {selectedReservation.clienteInfo.ruc || "No disponible"}</p>
                        <button onClick={closeModal2}>Cerrar</button>
                    </div>
                )}
            </Modal>

        </div>
    );
};

export default ReservasFiltradas;
